'use client';

import { LoadingScreen } from '@/components/common/LoadingScreen';
import { useAuthContext } from '@/contexts/auth';

export const PageContent = ({ children }: { children: React.ReactNode }) => {
	const { isLoading } = useAuthContext();

	if (isLoading) {
		return <LoadingScreen />;
	}
	return <div>{children}</div>;
};
